import * as React from 'react';
import { PageText } from './page-text';
import { PagingArrows } from './paging-arrows';

interface IPaginationProps extends IPaginationOptions {
    onPageSelect(page: number): void;
    pageText: string;
}

export interface IPaginationOptions {
    totalItems: number;
    pageSize: number;
    pageNumber: number;
}

export interface IFullPaginationOptions extends IPaginationOptions {
    totalPages: number;
}

/// <summary>
/// Renders pagination arrows and buttons
/// </summary>
export class Pagination extends React.Component<IPaginationProps, any> {
    render() {
        let calculatedTotalPages = Math.ceil(this.props.totalItems / this.props.pageSize);
        let boundedCurrentPage = this.props.pageNumber > calculatedTotalPages
            ? calculatedTotalPages
            : this.props.pageNumber;

        let fullPaginationOptions = {
            totalItems: this.props.totalItems,
            pageSize: this.props.pageSize,
            pageNumber: boundedCurrentPage,
            totalPages: calculatedTotalPages
        }

        return (
            <nav className="pagination" aria-label="Pages">
                <PageText paging={fullPaginationOptions} pageText={this.props.pageText} />
                <div className="pagination-controls">
                    <PagingArrows paging={fullPaginationOptions} isLeftArrows={true} onPageSelect={this.props.onPageSelect} />
                    <PagingArrows paging={fullPaginationOptions} isLeftArrows={false} onPageSelect={this.props.onPageSelect} />
                </div>
            </nav>
        );
    }
}
